<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { setAppLocale } from '@/shared/i18n'

const { locale } = useI18n()
</script>

<template>
  <div class="language-switch" role="group" :aria-label="locale === 'en' ? 'Language' : '语言'">
    <a-button type="text" class="language-switch-option" :class="{ 'is-active': locale === 'zh-CN' }"
      :aria-pressed="locale === 'zh-CN'" @click="setAppLocale('zh-CN')">中文</a-button>
    <a-button type="text" class="language-switch-option" :class="{ 'is-active': locale === 'en' }"
      :aria-pressed="locale === 'en'" @click="setAppLocale('en')">EN</a-button>
  </div>
</template>

<style scoped>
.language-switch {
  display: inline-flex;
  align-items: center;
  width: 96px;
  height: 32px;
  padding: 3px;
  border: 1px solid #c5d0e2;
  border-radius: 999px;
  background: #dce4f2;
  flex: none;
}

.language-switch-option.arco-btn {
  flex: 1;
  min-width: 0;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #4b5565;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
  box-shadow: none;
  transition: background-color 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.language-switch-option.arco-btn:hover {
  background: rgba(255, 255, 255, 0.35);
  color: #1d2939;
}

.language-switch-option.arco-btn.is-active,
.language-switch-option.arco-btn.is-active:hover {
  background: #f5f8ff;
  color: #1d2939;
  font-weight: 600;
  box-shadow: 0 1px 5px rgba(45, 65, 105, 0.15);
}

.language-switch-option.arco-btn:focus-visible {
  outline: 2px solid #246bfd;
  outline-offset: 1px;
}

@media (prefers-reduced-motion: reduce) {
  .language-switch-option.arco-btn { transition: none; }
}
</style>
